export default "__VITE_ASSET__CcYo00Il__"